import { Container, Select } from './styles'

Container.Select = Select

export default Container
